import { render, staticRenderFns } from "./ContentFilterPill.vue?vue&type=template&id=1cca42b0&scoped=true&"
import script from "./ContentFilterPill.vue?vue&type=script&lang=js&"
export * from "./ContentFilterPill.vue?vue&type=script&lang=js&"
import style0 from "./ContentFilterPill.vue?vue&type=style&index=0&id=1cca42b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cca42b0",
  null
  
)

export default component.exports